import React, { useCallback } from "react";
import styles from "./index.module.scss";
import iLogo from "@/modules/tm/assets/transfer/find-more.png";
import iClient from "@/modules/tm/assets/transfer/icon-client.png";
import iGlobal from "@/modules/tm/assets/transfer/icon-global.png";
import KST from "@/common/tools/kst";

const TMTransferNotFound: React.FC = (props) => {
  // --------------- Events ---------------

  // 联系客服
  const onTapClient = useCallback(() => {
    KST.call();
  }, []);

  // 国际商标
  const onTapInternational = useCallback(() => {
    KST.call();
  }, []);

  return (
    <div className={`${styles.container} flex-row flex-cross-axis-center`}>
      <img className={styles.logo} src={iLogo} alt="notfound" />
      <div className={styles.infoContainer}>
        <h2>不要急哦，好多好商标没有展示出来，马上联系服务顾问获取！</h2>
        <h1>没有找到您心仪的商标？</h1>
        <div className={`${styles.btnContainer} flex-row`}>
          <div className={`${styles.btn} flex-row-center`} onClick={onTapClient}>
            <img className={styles.icon} src={iClient} alt="" />
            <span>联系客服</span>
          </div>
          <div className={`${styles.btn} flex-row-center`} onClick={onTapInternational}>
            <img className={styles.icon} src={iGlobal} alt="" />
            <span>国际商标</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TMTransferNotFound;
